import React from 'react';
import { Ambientes, EstadoUsuarios, LasMonedas, ListaPlanes, Provincias, TiposIDDosDigitos } from '../Comunes/Listas';


const Datos = (props) => {

    return (<>
    <h4><u>Datos Generales</u></h4>
    
        <div className='row'>
        
            <div className='col-50'>
                <div className='row'>
                    <div className='col-25'>
                        <span className="col-form-span" >Contrato </span>
                        <input type="text" id="IdCia" disabled name="IdCia" autoComplete='off' value={props.Gestor.IdCia} onChange={props.CambiaDatosGestor}></input>
                    </div>
                    <div className='col-75'>
                        <span className="col-form-span" >Identificador </span>
                        <input type="text" disabled={props.Gestor.IdCia > 0} id="BDCompania" name="BDCompania" autoComplete='off' value={props.Gestor.BDCompania} onChange={props.CambiaDatosGestor}></input>
                    </div>
                </div>

            </div>
            <div className='col-50'>
                <div className='row'>
                    <div className='col-50'>
                        <span className="col-form-span" >Cédula </span>
                        <input type="text" id="Cedula" name="Cedula" autoComplete='off' value={props.Gestor.Cedula} onChange={props.CambiaDatosGestor}></input>
                    </div>
                    <div className='col-50'>
                        <span className="col-form-span" >Tipo Cedula </span>
                        <select id="TipoCedula" name="TipoCedula" className="form-group" onChange={props.CambiaDatosGestor} value={props.Gestor.TipoCedula}>
                            {TiposIDDosDigitos.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select>
                    </div>
                </div>
            </div>
        </div>
        <div className='row'>
            <div className='col-50'>
                <span className="col-form-span" >Razón Social </span>
                <input type="text" id="RazonSocial" name="RazonSocial" autoComplete='off' value={props.Gestor.RazonSocial} onChange={props.CambiaDatosGestor}></input>
            </div>
            <div className='col-50'>
                <span className="col-form-span" >Nombre Comercial </span>
                <input type="text" id="NombreComercial" name="NombreComercial" autoComplete='off' value={props.Gestor.NombreComercial} onChange={props.CambiaDatosGestor}></input>
            </div>

        </div>
        <div className='row'>
            <div className='col-50'>

            </div>
            <div className='col-50'>



            </div>

        </div>
        <div className='row'>
            <div className='col-25'>
                <span className="col-form-span" >Provincia </span>

                <select id="Provincia" name="Provincia" className="form-group" onChange={props.CambiaDatosGestor} value={props.Gestor.Provincia}>
                    {Provincias.map((option, i) => (
                        <option key={i} value={option.value}>{option.span}</option>
                    ))}</select>
            </div>
            <div className='col-25'>
                <span className="col-form-span" >Cantón </span>

                <select id="Canton" name="Canton" className="form-group" onChange={props.CambiaDatosGestor} value={props.Gestor.Canton}>
                    {props.LosCantones.map((option, i) => (
                        <option key={i} value={option.CANTON}>{option.NOMBRE}</option>
                    ))}</select>
            </div>

            <div className='col-25'>
                <span className="col-form-span" >Distrito </span>

                <select id="Distrito" name="Distrito" className="form-group" onChange={props.CambiaDatosGestor} value={props.Gestor.Distrito}>
                    {props.LosDistritos.map((option, i) => (
                        <option key={i} value={option.DISTRITO}>{option.NOMBRE}</option>
                    ))}</select>
            </div>
            <div className='col-25'>
                <span className="col-form-span" >Señas </span>
                <input type="text" id="OtrasSenas" name="OtrasSenas" autoComplete='off' value={props.Gestor.OtrasSenas} onChange={props.CambiaDatosGestor}></input>
            </div>
        </div>
        <div className='row'>
            <div className='col-50'>
                <span className="col-form-span" >Teléfono </span>
                <input type="text" id="Telefono" name="Telefono" autoComplete='off' value={props.Gestor.Telefono} onChange={props.CambiaDatosGestor}></input>
            </div>
            <div className='col-50'>
                <span className="col-form-span" >Correo </span>
                <input type="text" id="Correo" name="Correo" autoComplete='off' value={props.Gestor.Correo} onChange={props.CambiaDatosGestor}></input>
            </div>
        </div>
        <div className='row'>
            <div className='col-50'>
                <span className="col-form-span" >Cuenta Bancaria </span>
                <textarea id="NotaFactura" name="NotaFactura" value={props.Gestor.NotaFactura || ''} rows={7} onChange={props.CambiaDatosGestor}></textarea>
            </div>
            <div className='col-50'>
                <div className='row'>
                    <div className='col-50'>
                        <span className="col-form-span" >Plan </span>

                        <select id="NotaNC" name="NotaNC" className="form-group" onChange={props.CambiaDatosGestor} value={props.Gestor.NotaNC}>
                            {ListaPlanes.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select>
                    </div>
                    <div className='col-50'>
                        <span className="col-form-span" >Monto </span>
                        <input type="text" id="NotaND" name="NotaND" autoComplete='off' value={props.Gestor.NotaND} onChange={props.CambiaDatosGestor}></input>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-50'>
                        <span className="col-form-span" >Moneda </span>

                        <select id="NotaExtraDetalle" name="NotaExtraDetalle" className="form-group" onChange={props.CambiaDatosGestor} value={props.Gestor.NotaExtraDetalle}>
                            {LasMonedas.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select>
                    </div>
                    <div className='col-50'>
                        <span className="col-form-span" >Descuento </span>
                        <input type="text" id="SNcontado" name="SNcontado" autoComplete='off' value={props.Gestor.SNcontado} onChange={props.CambiaDatosGestor}></input>
                    </div>
                </div>

            </div>
        </div>
        <div className='row'>
            <div className='col-50'>

                <span className="col-form-span" >Logo </span>

                <input type="file" id="fileUpload" name="fileUpload" onChange={props.SubirLogo} />

                {props.InfoLicencia[0] ?
                    <img src={"data:image/*;base64," + props.InfoLicencia[0].LOGO} alt={'Logo'}
                        style={{ width: '100%', height: '100%', maxHeight: '190px' }} />
                    : null}
            </div>
            <div className='col-50'>
                <div className='row'>
                    <div className='col-50'>
                        <span className="col-form-span" >Estado </span>

                        <select id="ESTADO" name="ESTADO" className="form-group" onChange={props.CambiaInfoLicencia} value={props.InfoLicencia[0].ESTADO}>
                            {EstadoUsuarios.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select>
                    </div>
                    <div className='col-50'>
                        <span className="col-form-span" >Fecha Vencimiento </span>
                        <input type="date" id="FECHA" name="FECHA" autoComplete='off' value={new Date(props.InfoLicencia[0].FECHA).toISOString().split('T')[0]} onChange={props.CambiaInfoLicencia}></input>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-50'>
                        <span className="col-form-span" ># Cliente Pc Service </span>
                        <input type="text" id="CLIENTE" disabled name="CLIENTE" autoComplete='off' value={props.InfoLicencia[0].CLIENTE} onChange={props.CambiaInfoLicencia}></input>
                    </div>
                    <div className='col-50'>
                        <span className="col-form-span" >Ambiente </span>
                        <select id="Ambiente" name="Ambiente" className="form-group" value={props.Gestor.Ambiente} onChange={props.CambiaDatosGestor}>
                            {Ambientes.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select>
                    </div>
                </div>

            </div>
        </div>



    </>)

};
export default Datos;